import React, { useState, useEffect } from "react";

import * as yup from "yup";
import {
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";

export const DriverRegForm = () => {
  const navigate = useNavigate();
  const { userId, oId, role,pId } = useAuth();
  

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  // const [formData, setFormData] = useState({
  //   firstName: "",
  //   lastName: "",

  //   busNumber: "",
  //   routeNumber: "",
  //   busNumberPlate:'',
  //   driverPickupLocation: "",
  //   driverDropLocation: "",
  //   driverMobile: "",
  //   driverEmail: "",
  //   attendantMobile: "",
  // });
const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  busNumber: "",
  routeNumber: "",
  busNumberPlate: "",
  driverPickupLocation: "",
  driverDropLocation: "",
  driverMobile: "",
  driverEmail: "",
  employeeId: "",
  attenderId: "",
  attenderName: "",
  attendantMobile: "",
  teacherId: "",
  teacherName: "",
});

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [busNumbers, setBusNumbers] = useState([]);
  const [routeNumber, setrouteNumber] = useState([]);
  const [driverPickupLocation, setDriverPickupLocation] = useState([]);
  const [driverDropLocation, setDriverDropLocation] = useState([]);
  const [busNumberPlate, setBusNumberPlate] = useState([]);

  const [busLoading, setBusLoading] = useState(false);
  const [routeLoading, setRouteLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);

  const [driver, setDriver] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");

  const [attender, setAttender] = useState([]);
  const [selectedAttender, setSelectedAttender] = useState("");

    const [teachers, setTeachers] = useState([]);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  const [currentTab, setCurrentTab] = useState(0);



      const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`
        );
        if (!response.ok) {
          // throw new Error("Failed to fetch users");
          console.log("Failed to fetch Transport ids")
        }
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
      }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
   useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);

 
    const fetchDrivers = async () => {
      if(!UserId) return;
      try {
        const response = await fetch(`${baseUrl}/api/driver/getAllRolesIdsAndNames/byRole/${oId}/${pId}/${UserId}?role=DRIVER`);
        if (!response.ok) {
          // throw new Error("Failed to fetch employees");
          console.log("Failed to fetch Drivers")
        }
        const data = await response.json();
        setDriver(data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
 useEffect(() => {
    fetchDrivers();
  }, [UserId]);

  useEffect(() => {
    const fetchAttenders = async () => {
      if (!UserId) return;
      try {
        const response = await fetch(
          `${baseUrl}/api/driver/getAllRolesIdsAndNames/byRole/${oId}/${pId}/${UserId}?role=ATTENDER`
        );
        if (!response.ok) {
          // throw new Error("Failed to fetch employees");
          console.log("Failed to fetch Attenders")
        }
        const data = await response.json();
        setAttender(data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchAttenders();
  }, [UserId]);


//Teachers list api
useEffect(() => {
  async function fetchTeachers() {
    try {
      const response = await fetch(`${baseUrl}/api/driver/getAllTeachersForDrivers/${oId}/TEACHER/${pId}`);
      if (response.ok) {
        const data = await response.json();
        setTeachers(data);
      } else {
        console.error("Failed to fetch teachers");
      }
    } catch (error) {
      console.error("Error fetching teachers", error);
    }
  }
  fetchTeachers();
}, [oId]);








//BUS DETAILS
  useEffect(() => {
    const fetchData = async () => {
      if (!UserId) return;
      setBusLoading(true);
      setRouteLoading(true);

      try {
        const response = await fetch(
          `${baseUrl}/api/SchedulingRoute/available-bus-routes/${oId}/${UserId}`
        );
        if (!response.ok) {
          // throw new Error("Failed to fetch data");
          console.log("Failed to fetch Bus Routes")
        }

        const data = await response.json();
        console.log("Fetched Data:", data);

        const extractedBuses = data.map((item) => ({
          id: String(item.id),
          busNumber: item.busNumber || "Unknown Bus",
          routeNumber: item.routeNumber || "Unknown Route",
          busPickupLocation: item.busPickupLocation || "Unknown BusPickUpLocation",
          busDropLocation: item.busDropLocation || "Unknown BusDropLocation",
          busNumberPlate: item.busNumberPlate || "Unknown BusNumberPlate",
          // console.log("Fetched Data:"+ routeNumber);
        }));
        console.log("route no:" + routeNumber);

        setBusNumbers(extractedBuses);
        setrouteNumber(extractedBuses);
        setDriverPickupLocation(extractedBuses);
        setDriverDropLocation(extractedBuses);
        setBusNumberPlate(extractedBuses);
      } catch (error) {
        // toast.error(error.message);
        console.log("error: "+error.message)
      } finally {
        setBusLoading(false);
        setRouteLoading(false);
      }
    };

    fetchData();
  }, [baseUrl,UserId]);




  // const validationSchema = yup.object().shape({
  //   firstName: yup.string().required("Select Driver"),
  //   lastName: yup.string().required(),
  //   busNumber: yup.string().required("Bus Number is required"),
  //     attenderId: yup.string().required(" Select Attendant"),
  // });
  const validationSchema = yup.object().shape({
    firstName: yup.string().required("Select Driver"),
    lastName: yup.string().required("Last name is required"),
    busNumber: yup.string().required("Select Bus"),
    // attenderId: yup.string().required("Select Attendant"),
  });
  

  // Handle driver selection
  // const handleDriverChange = (event) => {
  //   const selectedDriver = driver.find(
  //     (emp) => emp.employeeId === event.target.value
  //   );
  //   if (selectedDriver) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       firstName: selectedDriver.firstName,
  //       lastName: selectedDriver.lastName,
  //       employeeId: selectedDriver.employeeId,
  //       driverMobile: selectedDriver.mobileNo || "",
  //       driverEmail: selectedDriver.email || "",
  //     }));
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       firstName: "",
  //       lastName: "",
  //     }));
  //   }
  // };
  const handleDriverChange = (event) => {
    const selectedDriver = driver.find(
      (emp) => emp.employeeId === event.target.value
    );
  
    if (selectedDriver) {
      setFormData((prevData) => ({
        ...prevData,
        firstName: selectedDriver.firstName,
        lastName: selectedDriver.lastName,
        employeeId: selectedDriver.employeeId,
        driverMobile: selectedDriver.mobileNo || "",
        driverEmail: selectedDriver.email || "",
      }));
  
      setErrors((prevErrors) => ({
        ...prevErrors,
        firstName: "",
      }));
    }
  };
  


  const handleAttendantChange = (event) => {
    const selectedEmployeeId = event.target.value;
    const selectedAttendant = attender.find(
      (emp) => emp.employeeId === selectedEmployeeId
    );
  
    if (selectedAttendant) {
      setFormData((prevData) => ({
        ...prevData,
        attenderId: selectedAttendant.employeeId || "",
        attenderName: `${selectedAttendant.firstName} ${selectedAttendant.lastName}` || "",
        attendantMobile: selectedAttendant.mobileNo || "",
      }));
  
      
    }
  };

const handleTeacherChange = (event) => {
    const selectedTeacherId = event.target.value;
    const selectedTeacher = teachers.find(
      (emp) => emp.teacherId === selectedTeacherId
    );
  
    if (selectedTeacher) {
      setFormData((prevData) => ({
        ...prevData,
        teacherId: selectedTeacher.teacherId || "",
        teacherName: `${selectedTeacher.teacherFirstName} ${selectedTeacher.teacherLastName}` || "",
        // attendantMobile: selectedTeacher.mobileNo || "",
      }));
  
     
    }
  };
  
  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Updated: ${name}, New Value: ${value}`);

    setFormData((prevData) => {
      let updatedFormData = { ...prevData, [name]: value };

      // Auto-select the route when a busNumber is chosen
      if (name === "busNumber") {
        const matchedBus = busNumbers.find((bus) => bus.busNumber === value);
        updatedFormData.routeNumber = matchedBus ? matchedBus.routeNumber : "";
        updatedFormData.busPickupLocation = matchedBus ? matchedBus.busPickupLocation : "";
        updatedFormData.busDropLocation = matchedBus ? matchedBus.busDropLocation : "";
        updatedFormData.busNumberPlate = matchedBus ? matchedBus.busNumberPlate : "";

        // ✅ Set driverPickupLocation same as busPickupLocation
      updatedFormData.driverPickupLocation = matchedBus ? matchedBus.busPickupLocation : "";
      updatedFormData.driverDropLocation = matchedBus ? matchedBus.busDropLocation : "";
      }

      return updatedFormData;
    });

    // Validate only if field exists in Yup schema
    if (validationSchema.fields[name]) {
      validationSchema
        .validateAt(name, { [name]: value })
        .then(() => {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        })
        .catch((error) => {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: error.message }));
        });
    }
  };


  
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // Validate form
    await validationSchema.validate(formData, { abortEarly: false });

    // Do NOT delete any field; include all fields even if empty
    const formDataObj = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataObj.append(key, value || ""); // ensures even `null`/`undefined` are converted to ""
    });

    const response = await fetch(`${baseUrl}/api/driver/save/${UserId}`, {
      method: "POST",
      body: formDataObj,
    });

    const data = await response.json();

    if (response.ok) {
      toast.success("Driver Registered successfully!", {
        position: "top-right",
        autoClose: 1000,
      });

      setTimeout(() => navigate("/DriversList"), 1000);

      setFormData({
        firstName: "",
        lastName: "",
        busNumber: "",
        routeNumber: "",
        busNumberPlate: "",
        driverPickupLocation: "",
        driverDropLocation: "",
        driverMobile: "",
        driverEmail: "",
        attenderId: "",
        attendantMobile: "",
        employeeId: "",
        attenderName: "",
        teacherId: "",
        teacherName: "",
      });

      setErrors({});
    } else {
      throw new Error(data.message || "Something went wrong!");
    }
  } catch (error) {
    if (error.name === "ValidationError") {
      const newErrors = {};
      error.inner.forEach((err) => {
        newErrors[err.path] = err.message;
      });
      setErrors(newErrors);
    } else {
      toast.error(error.message || "Something went wrong!", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  } finally {
    setLoading(false);
  }
};


  return (
    <Box
      sx={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Driver Registration Form
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            {/* <FormControl fullWidth error={!!errors.firstName}>
              <InputLabel>Select Driver</InputLabel>
              <Select
                value={
                  formData.firstName
                    ? driver.find((emp) => emp.firstName === formData.firstName)
                        ?.employeeId || ""
                    : ""
                }
                onChange={handleDriverChange}
                label="Select Driver"
              >
                {driver.map((emp) => (
                  <MenuItem key={emp.employeeId} value={emp.employeeId}>
                    {`${emp.employeeId} - ${emp.firstName} ${emp.lastName}`}
                  </MenuItem>
                ))}
              </Select>
              {errors.firstName && (
                <FormHelperText>{errors.firstName}</FormHelperText>
              )}
            </FormControl> */}
            <FormControl fullWidth error={!!errors.firstName}>
  <InputLabel>Select Driver</InputLabel>
  <Select
    value={
      formData.firstName
        ? driver.find((emp) => emp.firstName === formData.firstName)
            ?.employeeId || ""
        : ""
    }
    onChange={handleDriverChange}
    label="Select Driver"
  >
    {driver.length > 0 ? (
      driver.map((emp) => (
        <MenuItem key={emp.employeeId} value={emp.employeeId}>
          {`${emp.employeeId} - ${emp.firstName} ${emp.lastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No drivers available</MenuItem>
    )}
  </Select>
  {errors.firstName && (
    <FormHelperText>{errors.firstName}</FormHelperText>
  )}
</FormControl>

          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth error={!!errors.busNumber}>
              <InputLabel>Select Bus</InputLabel>
              <Select
                name="busNumber"
                value={formData.busNumber || ""}
                onChange={handleInputChange}
                label="Select Bus "
              >
                {busLoading ? (
                  <MenuItem disabled>Loading...</MenuItem>
                ) : busNumbers.length > 0 ? (
                  busNumbers.map((bus) => (
                    <MenuItem key={bus.id} value={bus.busNumber}>
                      {bus.busNumberPlate}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Buses Available</MenuItem>
                )}
              </Select>
              {errors.busNumber && (
                <FormHelperText>{errors.busNumber}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              fullWidth
              // error={!!errors.routeNumber}
              sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
            >
              <TextField
                name="routeNumber"
                value={formData.routeNumber || ""}
                label="Route No"
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: "#e0e0e0",
                    color: "#666",
                    borderRadius: "5px",
                    pointerEvents: "none",
                    "& .MuiInputBase-input": {
                      color: "#666",
                      cursor: "default",
                    },
                  },
                }}
              />
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4}>
            <FormControl
              fullWidth
              // error={!!errors.routeNumber}
              sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
            >
              <TextField
                name="busNumberPlate"
                value={formData.busNumberPlate || ""}
                label="Bus Number Plate"
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: "#e0e0e0",
                    color: "#666",
                    borderRadius: "5px",
                    pointerEvents: "none",
                    "& .MuiInputBase-input": {
                      color: "#666",
                      cursor: "default",
                    },
                  },
                }}
              />
            </FormControl>
          </Grid> */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              fullWidth
              sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
            >
              <TextField
                name="driverPickupLocation"
                value={formData.busPickupLocation || ""}
                label="Driver Pickup Location"
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: "#e0e0e0",
                    color: "#666",
                    borderRadius: "5px",
                    pointerEvents: "none",
                    "& .MuiInputBase-input": {
                      color: "#666",
                      cursor: "default",
                    },
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              fullWidth
              sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
            >
              <TextField
                name="driverDropLocation"
                value={formData.busDropLocation || ""}
                label="Driver Drop Location"
                InputProps={{
                  readOnly: true,
                  sx: {
                    backgroundColor: "#e0e0e0",
                    color: "#666",
                    borderRadius: "5px",
                    pointerEvents: "none",
                    "& .MuiInputBase-input": {
                      color: "#666",
                      cursor: "default",
                    },
                  },
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
           

           
<FormControl fullWidth >
  <InputLabel>Select Attendant</InputLabel>
  <Select
    value={formData.attenderId || ""} // Ensure correct binding
    onChange={handleAttendantChange}
    label="Select Attendant"
  >
    {attender.length > 0 ? (
      attender.map((emp) => (
        <MenuItem key={emp.employeeId} value={emp.employeeId}>
          {`${emp.employeeId} - ${emp.firstName} ${emp.lastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No attendants available</MenuItem>
    )}
  </Select>
</FormControl>
  </Grid>
{/* <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="Select Teacher"
                    value={values.teacherId}
                    onChange={(e) => {
                      const selectedTeacher = teachers.find((t) => t.teacherId === e.target.value);
                      setFieldValue("teacherId", selectedTeacher?.teacherId || "");
                      setFieldValue("teacherFirstName", selectedTeacher?.teacherFirstName || "");
                      setFieldValue("teacherLastName", selectedTeacher?.teacherLastName || "");
                    }}
                    error={touched.teacherId && Boolean(errors.teacherId)}
                    helperText={touched.teacherId && errors.teacherId}
                  >
                    <MenuItem value="">Select a teacher</MenuItem>
                    {teachers.map((teacher) => (
                      <MenuItem key={teacher.teacherId} value={teacher.teacherId}>
                        {teacher.teacherFirstName} {teacher.teacherLastName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

 <Grid item xs={12} sm={6} md={4}>
           

           
<FormControl fullWidth >
  <InputLabel>Select Teacher</InputLabel>
  <Select
    value={formData.teacherId || ""} // Ensure correct binding
    onChange={handleTeacherChange}
    label="Select Teacher"
  >
    {/* <MenuItem disabled>If Not Attender Select Teacher</MenuItem> */}
    {teachers.length > 0 ? (
      teachers.map((emp) => (
       
        <MenuItem key={emp.teacherId} value={emp.teacherId}>
          {`${emp.teacherId} - ${emp.teacherFirstName} ${emp.teacherLastName}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No Teachers available</MenuItem>
    )}
  </Select>
  
</FormControl>
</Grid>
        
          {/* {isPrincipal && ( // Show these only for Admin users
            <>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Select Transport Admin</InputLabel>
                  <Select
                    value={selectedUsers}
                    onChange={(e) => setSelectedUsers(e.target.value)}
                    label="Select Transport Admin"
                    // error={!!touched.userRoleName && !!errors.userRoleName}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user.userId}-{user.firstName} {user.lastName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )} */}
        </Grid>

        <Grid container justifyContent="right" sx={{ marginTop: 4 }}>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              sx={{
                padding: "10px 20px",
                backgroundColor: "#3C3972", // New green color
                width: "120px",
                "&:hover": {
                  backgroundColor: "#3C3972", // Darker shade for hover
                },
              }}
              // onClick={handleSubmit}
              disabled={loading} // Disable button when loading
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Register Bus"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>
      <ToastContainer position="top-right" autoClose={1000} />
    </Box>
  );
};